import CryptoJS from 'crypto-js'
import Cookies from 'js-cookie'
// 去除字符串前后空格
export function clearStringBlank(str) {
    if (typeof str === 'string') {
        return str.replace(/^\s+|\s+$/g,'')
    }
    return str
}

// 高亮关键词
export function repalceKeyword(keyword, contents, opt) {
    let newContents = contents
    if (!keyword || !contents) {
        return newContents
    }

    // 直接匹配到
    let values = contents.split(keyword)
    let _keword = '<' + opt.element + ' class="' + opt.className + '">' + keyword + '</' + opt.element + '>'
    newContents = values.join('╮╭')

    // 关键词拆分匹配
    keyword = toHeavy(keyword)
    for (let i = 0; i < keyword.length; i++) {
        newContents = _repalceKeyword(keyword[i], newContents, '╯!keyword!╰')
    }

    // 临时字符替换回来
    newContents = _repalceKeyword('╯', newContents, '<' + opt.element + ' class="' + opt.className + '">')
    newContents = _repalceKeyword('╰', newContents, '</' + opt.element + '>')
    newContents = _repalceKeyword('╮╭', newContents, _keword)
    return newContents
}

// 截取url id值
export function substrNum (url) {
    var strs = url.split('/')
    var num
    // M2: nginx 已放 token 进 SPA,substrNum 需认 21 字符 public_id token(NanoId)优先,回退数字 id
    var reg = /^[A-Za-z0-9_-]{21}$|^[0-9]+.?[0-9]*$/
    for (var i = 0; i < strs.length; i++) {
        if (reg.test(strs[i])) {
            num = strs[i]
            //console.log(num)
            return num
        }
    }
}

export function styleStr(color) {
    let str = `.about_text .about_text-l{background-color:${color}}.aboutus_header .login:hover,.aboutus_header .register:hover,.aboutus_header .loginOut:hover,.aboutus_header .username:hover { background: ${color};}
                .aboutus_header .register{ background: ${color}}.about_index_cnt .skin_color{color: ${color}}.about_index_cnt .notice_cnt .hover_style:hover{color:${color}}
                .about_text_cnt .about_text .about_text_r .look_more .down_icon{border-color:${color} transparent transparent}
                .about_index_cnt .about_text_cnt .about_text .about_text_r .look_more .down_icon.on{border-color:transparent transparent ${color}}.about_index_cnt .about_text_cnt .about_text .about_text_r.null .get_btn{background:${color}}
                li.cft_li .img_box .mb{border-color:${color}}.cft_li .img_box .mb .i1{ border-color:transparent ${color} transparent ${color};}.cft_li .img_box .mb .i2{ border-color:transparent ${color} transparent transparent;}
                .cft_li .img_box:hover + p{color:${color};font-weight: bold;}.about_index_cnt .cft_btn:hover,.img_view_cnt .cft_btn:hover{background:${color};border-color:${color}}.about_index_cnt .look_more_btn{border-color:${color};color:${color}}.about_index_cnt .look_more_btn:hover{background:${color};color:#fff}
                .pro_first_li .img_barcode .coad{border:2px solid ${color}}li.pro_first_li .img_barcode:hover + em{color:${color}}.about_index .pro_first_li button.active,.about_index .pro_third_li .service-info button.active,.about_index .pro_second_li .service-info button.active{background:${color};cursor:pointer}
                .pro_third_li .img_barcode:hover + .service-info em,.pro_second_li .img_barcode:hover + .service-info em{color:${color}}.title-search h4 em{border-left:solid 4px ${color}}
                .title-search .canpany-search button{background-color:${color}}.title-search .canpany-search input{border-right-color: ${color};}.el-pagination.is-background .el-pager li:not(.disabled).active{background:${color}}.el-pagination.is-background .el-pager li:hover{color:${color} !important}
                .el-pagination.is-background .el-pager li:not(.disabled).active:hover{color:#fff !important}.notices_list li a em{border-left: solid 9px ${color};border-right: solid 9px ${color};}.about_index_cnt .notice .notice_cnt .info:hover{color:${color}}.about_index_cnt .notice .notice_cnt .info:hover i{background:${color}}
                .about_index .pro_second_li .service-info em:hover,.about_index .pro_third_li .service-info em:hover{color:${color}}.about_index .cft_li p:hover{color:${color}}.about_index_cnt .pro_first_li em:hover{color:${color}}`
    return str
}
// 替换关键词
function _repalceKeyword(keyword, contents, newStr) {
    let newContents = contents
    if (!keyword || !contents) {
        return newContents
    }
    newStr = newStr.replace('!keyword!', keyword)
    let values = contents.split(keyword)
    newContents = values.join(newStr)
    return newContents
}

// 去重
function toHeavy(str) {
    let newStr = ''
    let flag
    for (let i = 0; i < str.length; i++) {
        flag = 1
        for (let j = 0; j < newStr.length; j++) {
            if (str[i] === newStr[j]) {
                flag = 0
                break
            }
        }
        if (flag) {
            newStr += str[i]
        }
    }
    return newStr
}

// 种cookie
export function secretCookie () {
    const ip = '127.0.0.1'
    const ua = navigator.userAgent
    const test = ua.slice(0, ua.length - 20)
    const code = '100000'
    const key = 'gk6tyNS6o*R,w81kZnPAm*7@+a85-9uG'
    const cookieName = CryptoJS.MD5(code + key).toString()
    if (!Cookies.get(cookieName)) {
        const date = new Date()
        date.setTime(date.getTime() + 60 * 60 * 1000)
        Cookies.set(cookieName, CryptoJS.MD5(ip + test).toString(), {expires: date, path: '/', domain: '.gxzg.org.cn'})
    }
}

// 删除cookie 返回数组
export function removeSearchCookie (name) {
    if (Cookies.get(name)) {
        Cookies.remove(name)
    }
}
// 获取cookie 返回数组
export function getSearchCookie (name) {
    if (Cookies.get(name)) {
        return Cookies.get(name).split(',')
    } else {
        return []
    }
}


// TODO
// str 关键字
// arr 改变的数组
// opt.keyName arr中obj字段名
// opt.className 要更改的标签class
// opt.element 用什么元素包含
// export function setStringMark (str, arr, opt) {
//     if (!str || !opt) {
//         return arr
//     }
//     if (!arr) {
//         return []
//     }
//     let arrReturn = []
//     opt.forEach((currentValue) => {
//
//     })
//     return arrReturn
// }



// WEBPACK FOOTER //
// ./src/tools/tool.js